/*
 * @Date: 2022-07-05 20:04:19
 * @LastEditors: hanhuixian hanhuixian@lxrental.com
 * @desc: 财务信息
 */
import DefaultLayout from '@/layout/index'

const baseLangKey = 'layout.headerBar';

export default   {
  name: 'finance',
  path: '/finance',
  redirect: '/finance/quarter',
  component: DefaultLayout,
  children: (pre => [
    {
      path: 'quarter',
      name: `${pre}quarter`,
      meta: {
        title: '中期报告',
        langKey: baseLangKey + '.quarter'
      },
      component: () => import('@/views/finance/quarter/index.vue')
    },
    {
      path: 'year',
      name: `${pre}year`,
      meta: {
        title: '年度报告',
        langKey: baseLangKey + '.year'
      },
      component: () => import('@/views/finance/year/index.vue')
    },
  ])('finance-')
}